import React from "react";
import { connect } from "react-redux";
import RmgScoreWidget from "../helpers/rmg_score_widget.jsx";

import { policyYear } from "../../shared/ducks/survey.js";
import { policyYearRange } from "../../../../shared/utils/policy_year.js";

let RmgHeader = ({ renderAsReadOnly, organization, policyYear }) => (
  <div>
    <p data-behavior="printed-at-timestamp" style={{ display: "none" }}></p>

    <div className="page-header">
      <h1>Risk Management Assessment</h1>
    </div>

    {renderAsReadOnly && organization && (
      <div>
        <hr />
        <div className="alert alert-info clearfix">
          <h3 className="pull-left no-margin-bottom no-margin-top">
            {organization.name}
          </h3>
          <span className="label label-sm label-right label-danger">
            Read-only
          </span>
          <strong className="pull-right">{policyYearRange(policyYear)}</strong>
        </div>
      </div>
    )}

    <div className="row">
      <div className="rmg-instructional-text col-sm-9">
        <p>
          We promote and encourage actions or inactions members take to reduce the frequency and/or 
          severity of losses. The Risk Management Assessment (RMA) focuses on specific areas of risk 
          management best practices. Members who score 100% on the assessment may be eligible for a 
          policy premium discount. It is important that the manager of your entity reviews the 
          completed RMA for awareness.
        </p>

        <p>
          <span className="small-text">
            Questions are based on your current coverage(s). All recommended trainings and policies 
            are offered through VRSA or the VRSA Online University.
          </span>
        </p>
      </div>

      <RmgScoreWidget />
    </div>
  </div>
);

export default connect((state, props) => ({
  policyYear: policyYear(state.survey),
  renderAsReadOnly: state.lookups.renderAsReadOnly,
  organization: state.lookups.organization,
}))(RmgHeader);
